import HorizontalGallery from "../components/horizontalGallery";
import WebsiteCount from "../components/websiteCount";
import Quote from "../components/Quote";
import CreateCard from "../components/CreateCard";
import Trending from "../components/Trending";
import Footer from "../components/Footer";

function Toppick() {
  const images = [
    {
      id: 1,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/When+Life+Gives+You+Tangerines%2C+%E1%84%91%E1%85%A9%E1%86%A8%E1%84%8A%E1%85%A1%E1%86%A8%E1%84%89%E1%85%A9%E1%86%A8%E1%84%8B%E1%85%A1%E1%86%BB%E1%84%89%E1%85%AE%E1%84%83%E1%85%A1+(2025).jpeg",
      alt: "When Life Gives You Tangerines",
      title: "When Life Gives You Tangerines",
      rating: "5/5",
    },
    {
      id: 2,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/FirstFrost.jpeg",
      alt: "First frost",
      title: "First frost",
      rating: "3.9/5",
    },

    {
      id: 3,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(10).jpeg",
      alt: "My dearest nemesis",
      title: "My dearest nemesi",
      rating: "2.9/5",
    },
    {
      id: 4,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/LOVE+SCOUT.jpeg",
      alt: "Love scout",
      title: "Love scout",
      rating: "3.6/5",
    },
    {
      id: 5,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/When+the+Stars+Gossip_.jpeg",
      alt: "When the star gossip",
      title: "When the star gossip",
      rating: "3.0/5",
    },
    {
      id: 6,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(6).jpeg",
      alt: "Friendly rivalry",
      title: "Friendly rivalry",
      rating: "3.5/5",
    },
    {
      id: 7,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/StudyGroup.jpeg",
      alt: "Study group",
      title: "Study group",
      rating: "4.5/5",
    },
    {
      id: 8,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(14).jpeg",
      alt: "Bon Appétit, Your Majesty",
      title: "Bon Appétit, Your Majesty",
      rating: "4.7/5",
    },
    {
      id: 9,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Head+Over+Heels.jpeg",
      alt: "Head over heels",
      title: "Head over heels",
      rating: "3.4/5",
    },
    {
      id: 10,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Unknown+Seoul.jpeg",
      alt: "Our unwritten soul",
      title: "Our unwritten soul",
      rating: "4.5/5",
    },
    {
      id: 11,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/%23WeakHeroClass2.jpeg",
      alt: "Weak hero class 2",
      title: "Weak hero class 2",
      rating: "3.8/5",
    },
    {
      id: 12,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/A+Hundred+Memories+Kdrama+Poster.jpeg",
      alt: "A hundred memories",
      title: "A hundred memories",
      rating: "4.7/5",
    },
    {
      id: 13,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/beyond+the+bar.jpeg",
      alt: "Beyond the bar",
      title: "Beyond the bar",
      rating: "4.7/5",
    },
    {
      id: 14,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(15).jpeg",
      alt: "Tastefully yours",
      title: "Tastefully yours",
      rating: "3.0/5",
    },
    {
      id: 15,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(16).jpeg",
      alt: "Pump up the healthy love",
      title: "pump up the healthy love",
      rating: "3.5/5",
    },
    {
      id: 16,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/You+and+Everything+Else+2025+_+%D0%A2%D1%8B+%D0%B8+%D0%B2%D1%81%D0%B5%CC%88+%D0%BE%D1%81%D1%82%D0%B0%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5+2025.jpeg",
      alt: "You and everything else",
      title: "You and everything else",
      rating: "3.6/5",
    },
    {
      id: 17,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/%D0%9A%D0%B0%D0%BA+%D0%B2+%D0%BA%D0%B8%D0%BD%D0%BE_Melo+Movie+(Drama%2C+2025%2C+%E1%84%86%E1%85%A6%E1%86%AF%E1%84%85%E1%85%A9%E1%84%86%E1%85%AE%E1%84%87%E1%85%B5).jpeg",
      alt: "Melo movie",
      title: "Melo movie",
      rating: "3.5/5",
    },
    {
      id: 18,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/RESIDENT+PLAYBOOK.jpeg",
      alt: "resident playbook",
      title: "resident playbook",
      rating: "4.3/5",
    },
    {
      id: 19,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/GoodBoy.jpeg",
      alt: "Good boy",
      title: "Good boy",
      rating: "3.5/5",
    },
    {
      id: 20,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/As+You+Stood+By.jpeg",
      alt: "As you stood by",
      title: "As you stood by",
      rating: "4.2/5",
    },
    {
      id: 21,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(19).jpeg",
      alt: "Cashero",
      title: "Cashero",
      rating: "4.1/5",
    },
  ];

  const bestOf2024 = [
    {
      id: 1,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Squid+Game+2.jpeg",
      alt: "Squid game season 2",
      title: "Squid game season 2",
      rating: "4.5/5",
    },
    {
      id: 2,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(11).jpeg",
      alt: "Brewing love",
      title: "Brewing love",
      rating: "3.2/5",
    },
    {
      id: 3,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/lovelyrunner.jpeg",
      alt: "Lovely runner",
      title: "Lovely runner",
      rating: "4.9/5",
    },
    {
      id: 4,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(12).jpeg",
      alt: "Mr Plankton",
      title: "Mr Plankton",
      rating: "3.5/5",
    },
    {
      id: 5,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/The+Trunk+k-drama+2024.jpeg",
      alt: "Trunk",
      title: "Trunk",
      rating: "3.5/5",
    },
    {
      id: 6,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Family+by+Choice.jpeg",
      alt: "Family by choice",
      title: "Family by choice",
      rating: "3.5/5",
    },
    {
      id: 7,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(13).jpeg",
      alt: "Light shop",
      title: "Light shop",
      rating: "4.6/5",
    },
    {
      id: 8,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Yoo+yeon+seok+y+Chae+Soo-bin+cuando+el+tele%CC%81fono+suena.jpeg",
      alt: "When the phone rings",
      title: "When the phone rings",
      rating: "4.2/5",
    },
    {
      id: 9,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Soompi_+Latest+K-Pop%2C+K-Drama%2C+Korean+Entertainment+News+(2024).jpeg",
      alt: "Love next door",
      title: "Love next door",
      rating: "2.5/5",
    },
    {
      id: 10,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Doctor+Slump+K-drama+Official+Poster+Netflix.jpeg",
      alt: "Doctor slump",
      title: "Doctor slump",
      rating: "2.6/5",
    },
    {
      id: 11,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/153_+Twinkling+Watermelon.jpeg",
      alt: "Twinkling watermelon",
      title: "Twinkling watermelon",
      rating: "4.3/5",
    },
    {
      id: 12,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(17).jpeg",
      alt: "The 8 show",
      title: "The 8 show",
      rating: "4.3/5",
    },

    {
      id: 13,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Marry+My+Husband.jpeg",
      alt: "Marry my husband",
      title: "Marry my husband",
      rating: "4.0/5",
    },
    {
      id: 14,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Death's+Game.jpeg",
      alt: "Death's game",
      title: "Death's game",
      rating: "4.2/5",
    },
  ];

  const timelessClassic = [
    {
      id: 1,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Reply1988.jpeg",
      alt: "Reply 1988",
      title: "Reply 1988",
      rating: "5/5",
    },
    {
      id: 2,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/When+Life+Gives+You+Tangerines%2C+%E1%84%91%E1%85%A9%E1%86%A8%E1%84%8A%E1%85%A1%E1%86%A8%E1%84%89%E1%85%A9%E1%86%A8%E1%84%8B%E1%85%A1%E1%86%BB%E1%84%89%E1%85%AE%E1%84%83%E1%85%A1+(2025).jpeg",
      alt: "When life gives you tangerines",
      title: "When life gives you tangerines",
      rating: "5/5",
    },
    {
      id: 3,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/legend.jpeg",
      alt: "Legend of blue sea",
      title: "Legend of blue sea",
      rating: "4.9/5",
    },
    {
      id: 4,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Strong+woman+Do+bong+Soon.jpeg",
      alt: "Strong girl boong soon",
      title: "Strong girl boong soon",
      rating: "5/5",
    },
    {
      id: 5,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/AlchemyOfSouls.jpeg",
      alt: "Alchemy of souls",
      title: "Alchemy of souls",
      rating: "4.6/5",
    },
    {
      id: 6,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/U%CC%88zleti+Aja%CC%81nlat.jpeg",
      alt: "Business proposal",
      title: "Business proposal",
      rating: "4.7/5",
    },
    {
      id: 7,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Truebeauty.jpeg",
      alt: "True beauty",
      title: "True beauty",
      rating: "4.6/5",
    },
    {
      id: 8,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/goblin.jpeg",
      alt: "Goblin",
      title: "Goblin",
      rating: "4.9/5",
    },
    {
      id: 9,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/CrashLandingonYouK-dramaOfficialposterNetflix.jpeg",
      alt: "Crash Landing on You",
      title: "Crash Landing on You",
      rating: "4.9/5",
    },
    {
      id: 10,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/twenty+five+twenty+one+poster.jpeg",
      alt: "Twenty five twenty one",
      title: "Twenty five twenty one",
      rating: "3.6/5",
    },
  ];

  const comingOfAgeRomance = [
    {
      id: 1,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/When+I+fly+towards+you+chinese+drama.jpeg",
      alt: "When I fly towards you",
      title: "When I fly towards you",
      rating: "4.8/5",
    },
    {
      id: 2,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/HidenLove.jpeg",
      alt: "Hidden love",
      title: "Hidden love",
      rating: "4.6/5",
    },
    {
      id: 3,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Truebeauty.jpeg",
      alt: "True beauty",
      title: "True beauty",
      rating: "4.7/5",
    },
    {
      id: 4,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/153_+Twinkling+Watermelon.jpeg",
      alt: "Twinkling watermelon",
      title: "Twinkling watermelon",
      rating: "4.2/5",
    },
    {
      id: 5,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Head+Over+Heels.jpeg",
      alt: "Head over heels",
      title: "Head over heels",
      rating: "3.4/5",
    },
    {
      id: 6,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/lovelyrunner.jpeg",
      alt: "lovely runner",
      title: "lovely runner",
      rating: "4.9/5",
    },
    {
      id: 7,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/AlwaysHome.jpeg",
      alt: "Always home",
      title: "Always home",
      rating: "3.5/5",
    },
  ];

  const bestof2026Yet = [
    {
      id: 1,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(21).jpeg",
      alt: "We are all trying here",
      title: "We are all trying here",
      rating: "5/5",
    },
    {
      id: 2,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(22).jpeg",
      alt: "My royal nemsis",
      title: "My royal nemsis",
      rating: "4.1/5",
    },
    {
      id: 3,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(23).jpeg",
      alt: "Perfect crown",
      title: "Perfect crown",
      rating: "3.5/5",
    },
    {
      id: 4,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Netflix+releases+new+couple+photo+for+_Can+This+Love+Be+Translated_+stars+Kim+Seon+Ho+and+Go+Youn+Jung_+%F0%9F%8D%80%F0%9F%92%96%E2%9C%A8%EF%B8%8F.jpeg",
      alt: "Can this love be translated",
      title: "Can this love be translated",
      rating: "4.5/5",
    },
    {
      id: 5,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/_+(24).jpeg",
      alt: "if wishes could kill",
      title: "if wishes could kill",
      rating: "4.7/5",
    },
    {
      id: 6,
      src: "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/The+Wonderfools+kdrama.jpeg",
      alt: "The wonderfools",
      title: "The wonderfools",
      rating: "4.9/5",
    }


  ];

  return (
    <>
      <WebsiteCount></WebsiteCount>
      <Quote></Quote>
      <Trending></Trending>
      <CreateCard></CreateCard>

      <div style={{ marginTop: "100px" }}>
        <header
          className="top-pick-header"
          style={{ display: "flex", alignItems: "center", color: "#800080" }}
        >
          <div
            style={{
              fontSize: "2.5em",
              fontWeight: "bold",
              margin: "0",
              marginRight: "5px",
            }}
          >
            Top picks
          </div>
          <svg
            width="24"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
            className="ipc-icon ipc-icon--chevron-right-inline ipc-icon--inline ipc-title-link ipc-title-link-chevron"
            viewBox="0 0 24 24"
            fill="white"
            role="presentation"
          >
            <path d="M5.622.631A2.153 2.153 0 0 0 5 2.147c0 .568.224 1.113.622 1.515l8.249 8.34-8.25 8.34a2.16 2.16 0 0 0-.548 2.07c.196.74.768 1.317 1.499 1.515a2.104 2.104 0 0 0 2.048-.555l9.758-9.866a2.153 2.153 0 0 0 0-3.03L8.62.61C7.812-.207 6.45-.207 5.622.63z"></path>
          </svg>
        </header>

        <span
          style={{
            display: "block",
            color: "yellow",
            marginTop: "15px",
            fontSize: "20px",
          }}
        >
          Best of 2026 Yet
        </span>
        <HorizontalGallery images={bestof2026Yet} />

        <span
          style={{
            display: "block",
            color: "yellow",
            marginTop: "15px",
            fontSize: "20px",
          }}
        >
          Best of 2025
        </span>
        <HorizontalGallery images={images} />
        <span
          style={{
            display: "block",
            color: "yellow",
            marginTop: "15px",
            fontSize: "20px",
          }}
        >
          Best of 2024
        </span>
        <HorizontalGallery images={bestOf2024} />
        <span
          style={{
            display: "block",
            color: "yellow",
            marginTop: "15px",
            fontSize: "20px",
          }}
        >
          {" "}
          Timeless classics
        </span>
        <HorizontalGallery images={timelessClassic} />
        <span
          style={{
            display: "block",
            color: "yellow",
            marginTop: "15px",
            fontSize: "20px",
          }}
        >
          Coming of age romance
        </span>
        <HorizontalGallery images={comingOfAgeRomance} />
      </div>
      <Footer></Footer>
    </>
  );
}

export default Toppick;
